import {Component, Input} from "@angular/core";
import {animate, state, style, transition, trigger} from "@angular/animations";

@Component({
    animations: [
        trigger("fade", [
            state("void", style({
                opacity: 0
            })),
            state("true", style({
                opacity: 1
            })),
            transition("* => *", animate("250ms 0s ease"))
        ])
    ],
    selector: "fui-modal",
    styleUrls: ["./modal.component.scss"],
    templateUrl: "./modal.component.html"
})
export class FUIModalComponent {
    @Input() public state: boolean = false;
    @Input() maxWidth: string;
    @Input() maxHeight: string;

    constructor() {

    }
}
